<template>
  <div class="repeat-page">
    <h1 class="title">
      {{ $t('message["1355"]') }}
    </h1>
    <div
      v-if="searchConfig"
      class="search-form clearfix"
    >
      <a-input-group
        compact
        class="fl"
      >
        <a-select
          v-if="searchConfig.key"
          :value="searchConfig.key"
          @change="handleChange"
        >
          <a-select-option
            v-for="item in searchConfig.options"
            :key="item.fieldkey"
            :value="item.fieldkey"
          >
            {{ item.fieldname }}
          </a-select-option>
          <i
            slot="suffixIcon"
            class="iconfont iconicon-test19"
          />
        </a-select>
        <a-input
          v-model="searchConfig.value"
          :placeholder="searchConfig.placeholder"
          @change="handleInput"
          @keyup.enter="onSearch"
        />
      </a-input-group>
      <a-button
        type="primary"
        class="fl search-btn"
        @click="onSearch"
      >
        {{ $t('message["91"]') }}
      </a-button>
      <a-button
        type="default"
        class="fl reset-btn"
        @click="onReset"
      >
        {{ $t('message["1625"]') }}
      </a-button>
    </div>
    <my-table
      ref="repeatTable"
      :checkrepeatfieldkey="searchConfig.key || repeatfieldkey"
      :checkrepeatfieldvalue="searchConfig.value || repeatfieldvalue"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import MyTable from './Table'

export default {
  components: {
    MyTable
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('inquery/repeatData', [
      'searchConfig'
    ]),
    repeatfieldkey () {
      return this.$route.query.repeatfieldkey || ''
    },
    repeatfieldvalue () {
      return this.$route.query.repeatfieldvalue || ''
    }
  },
  /* watch: {
    '$route' (to, from) {
      this.getSearchConfig()
    }
  }, */
  created () {
    this.getSearchConfig()
    this.searchConfig.value = ''
  },
  methods: {
    ...mapActions('inquery/repeatData', ['fetchSearchConfig', 'setSearchConfig', 'clearList']),
    ...mapMutations('inquery/repeatData', ['SET_SEARCHED', 'RESET_PAGINATION']),
    async getSearchConfig (params) {
      const chain = await this.fetchSearchConfig({
        repeatfieldkey: this.repeatfieldkey,
        repeatfieldvalue: this.repeatfieldvalue
      })
      chain
        .params({ ...params })
        .onNetSuccess(res => {
          document.title = this.$t('message["1355"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
        })
        .fetch()
    },
    onSearch () {
      let params = {}
      params.fieldkey = this.searchConfig.key
      params.fieldvalue = this.searchConfig.value
      // console.log(params)
      // if (params.fieldkey && params.fieldvalue) {
      // this.searched = true
      this.SET_SEARCHED(true)
      this.RESET_PAGINATION()
      this.$router.push({
        name: 'InqueryRepeat',
        query: {
          ...this.$route.query,
          page: 0,
          limit: 10,
          _t: new Date().getTime()
        }
      })
      // this.$refs.repeatTable && this.$refs.repeatTable.getRepeatList()
      // }
    },
    onReset () {
      this.searchConfig.value = ''
      this.searchConfig.key = this.searchConfig.options[0].fieldkey
      this.searchConfig.placeholder = `${this.$t('message["751"]')} ${this.searchConfig.options[0].fieldname}`

      this.clearList()
      this.$forceUpdate()
    },
    handleInput () {
      this.setSearchConfig(this.searchConfig)
    },
    handleChange (val) {
      this.searchConfig.key = val
      for (let item of this.searchConfig.options) {
        if (item.fieldkey === this.searchConfig.key) {
          this.searchConfig.placeholder = `${this.$t('message["751"]')} ${item.fieldname}`
        }
      }
      this.setSearchConfig(this.searchConfig)
    }
  }
}
</script>

<style lang="scss" scoped>
.repeat-page {
  // overflow: hidden;
}
.search-form ::v-deep {
  .ant-input-group {
    width: auto;
    margin-right: 16px;
  }
  .ant-select {
    width: 132px;
  }
  .ant-input {
    width: 240px;
  }
  .ant-btn {
    margin-right: 16px;
  }

  .ant-select-arrow {
    margin-top: -8px;
  }
}
</style>
